package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.PermissionType
import kotlinx.serialization.Serializable

@Serializable
enum class UserPermissionCommunity(private val literal: String) : PermissionType {
	发起话题("发起话题"),
	评论话题("评论话题"),
	编辑评论内容("编辑评论内容");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "user_permission_community"}
	override fun getLiteral(): String {return literal}
}
